import { createFeatureSelector, createSelector } from '@ngrx/store';
import { YearsEndPostingReducer } from '../reducers';

export const selectYearsEndPostingFeature = createFeatureSelector<YearsEndPostingReducer.YearsEndPostingState>(YearsEndPostingReducer.featureName);

export const selectYearsEndPosting = createSelector(selectYearsEndPostingFeature, (state: YearsEndPostingReducer.YearsEndPostingState) => state.item);
